import DashboardIcon from "assets/icons/mono/DashboardIcon";
import { WHATSAPP_SUPPORT_NUMBER } from "constants/global";
import { PRIVILEGE } from "constants/privilege";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "store";

const Navdata = () => {
    const history = useNavigate();
    //state data
    const [isDashboard, setIsDashboard] = useState(false);
    const [isApps, setIsApps] = useState(false);
    const [isAuth, setIsAuth] = useState(false);
    const [isPages, setIsPages] = useState(false);
    const [isBaseUi, setIsBaseUi] = useState(false);
    const [isAdvanceUi, setIsAdvanceUi] = useState(false);
    const [isForms, setIsForms] = useState(false);
    const [isTables, setIsTables] = useState(false);
    const [isCharts, setIsCharts] = useState(false);
    const [isIcons, setIsIcons] = useState(false);
    const [isMaps, setIsMaps] = useState(false);
    const [isMultiLevel, setIsMultiLevel] = useState(false);

    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");

                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        if (iscurrentState !== 'Apps') {
            setIsApps(false);
        }
        if (iscurrentState !== 'Auth') {
            setIsAuth(false);
        }
        if (iscurrentState !== 'Pages') {
            setIsPages(false);
        }
        if (iscurrentState !== 'BaseUi') {
            setIsBaseUi(false);
        }
        if (iscurrentState !== 'AdvanceUi') {
            setIsAdvanceUi(false);
        }
        if (iscurrentState !== 'Forms') {
            setIsForms(false);
        }
        if (iscurrentState !== 'Tables') {
            setIsTables(false);
        }
        if (iscurrentState !== 'Charts') {
            setIsCharts(false);
        }
        if (iscurrentState !== 'Icons') {
            setIsIcons(false);
        }
        if (iscurrentState !== 'Maps') {
            setIsMaps(false);
        }
        if (iscurrentState !== 'MuliLevel') {
            setIsMultiLevel(false);
        }
        if (iscurrentState === 'Widgets') {
            history("/widgets");
            document.body.classList.add('twocolumn-panel');
        }
    }, [
        history,
        iscurrentState,
        isDashboard,
        isApps,
        isAuth,
        isPages,
        isBaseUi,
        isAdvanceUi,
        isForms,
        isTables,
        isCharts,
        isIcons,
        isMaps,
        isMultiLevel
    ]);

    const privileges = useSelector((state: RootState) => state.auth.privileges);

    const hasPrivilege = (privilege: string) => {
        return privileges.includes(privilege);
    }



    const menuItems: any = [
        {
            label: "Menu",
            isHeader: true,
        },
        {
            id: "dashboard",
            label: "Dashboard",
            icon: "bx bxs-dashboard",
            iconSVG: <DashboardIcon />,
            link: "/",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('Dashboard');
                updateIconSidebar(e);
            },
            hasPrivilege: true,
        },
        {
            id: "creators",
            label: "Creators",
            icon: "bx bxs-group",
            link: "/creators",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('creators');
                updateIconSidebar(e);
            },
            hasPrivilege: hasPrivilege(PRIVILEGE.HUB.USER.INDEX), // TODO: Add privilege for creators
        },
        {
            id: "campaigns",
            label: "Campaigns",
            icon: "bx bxs-megaphone",
            link: "/campaign",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('campaigns');
                updateIconSidebar(e);
            },
            hasPrivilege: true, // TODO: Add privilege for campaigns
        },
         
        {
            id: "applications",
            label: "Applications",
            icon: "bx bx-folder-open",
            link: "/application",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('applications');
                updateIconSidebar(e);
            },
            hasPrivilege: true, // TODO: Add privilege for applications
        },
        // {
        //     id: "collaborations",
        //     label: "Collaborations",
        //     icon: "bx bx-star",
        //     link: "/collaborations",
        //     stateVariables: isDashboard,
        //     click: function (e: any) {
        //         e.preventDefault();
        //         setIsDashboard(!isDashboard);
        //         setIscurrentState('collaborations');
        //         updateIconSidebar(e);
        //     },
        //     hasPrivilege: privileges.includes(PRIVILEGE.CAMPAIGN.COLLABORATION.INDEX),
        // },
        {
            id: "tasks",
            label: "Collaborations",
            icon: "bx bx-task",
            link: "/tasks",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('tasks');
                updateIconSidebar(e);
            },
            hasPrivilege: privileges.includes(PRIVILEGE.CAMPAIGN.COLLABORATION.INDEX),
        },
        {
            id: "chat",
            label: "Chat",
            icon: "bx bx-chat",
            link: "/chat",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('chat');
                updateIconSidebar(e);
            },
            hasPrivilege: true, // TODO: Add privilege for chat
        },
        {
            id: "support",
            label: "Support",
            icon: "bx bx-support",
            link: `https://wa.me/${WHATSAPP_SUPPORT_NUMBER}`,
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
            },
            hasPrivilege: true,
        },
        // {
        //     id: "users",
        //     label: "Users",
        //     icon: "bx bxs-user",
        //     link: "/user",
        //     stateVariables: isDashboard,
        //     click: function (e: any) {
        //         e.preventDefault();
        //         setIsDashboard(!isDashboard);
        //         setIscurrentState('users');
        //         updateIconSidebar(e);
        //     },
        //     hasPrivilege: hasPrivilege(PRIVILEGE.HUB.USER.INDEX),
        // },
    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;